import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import classes from './Blocked.css';
import * as actions from '../../store/actions/index';
import { updateObject, checkValidity } from '../../shared/utility';

class Blocked extends Component {
    state = {
        
    }

    render () {


        return (
            <div className={classes.Auth}>

             <h1>Sorry this session was not authenticated please try again</h1>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {

    };
};

const mapDispatchToProps = dispatch => {
    return {
    
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Blocked );
